import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { UnidataTable } from '~/components';
import { t, number } from '~/helpers';
// import { formatISO } from '~/helpers/dateTime';
import { parseISO, format } from 'date-fns';
import moment from 'moment';
import { handleExportGeneric } from '~/helpers/exportReports';
import {
  deleteOperacaoDreno,
  findOperacaoDreno,
  recordFiltering,
} from '~/store/modules/operacaodreno/actions';
import FormDreno from './form';

const start = moment().set({ hour: 0, minute: 0, second: 0 });
const end = moment().set({ hour: 23, minute: 59, second: 59 });

export default function OperacaoDrenoList() {
  const redux = useSelector((state) => state.operacaodreno);
  const header = useMemo(
    () => [
      {
        id: 'datahoradreno_inicio',
        label: t('s.relatorio.geral.datahorainicio'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm:ss'),
        filter: {
          type: 'initialdatetime',
          defaultValue: start.format('DD/MM/YYYY HH:mm:ss'),
        },
      },
      {
        id: 'datahoradreno',
        label: t('s.relatorio.geral.datahorafim'),
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm:ss'),
        filter: {
          type: 'finaldatetime',
          defaultValue: end.format('DD/MM/YYYY HH:mm:ss'),
        },
      },
      {
        id: 'nomeabreviadoposto',
        label: t('s.operacao.turno.posto'),
        filter: { type: 'text' },
      },
      {
        id: 'idtanquevirtual',
        label: t('s.relatorio.geral.tanquevirtual'),
        filter: { type: 'text' },
      },
      {
        id: 'codigotanquefisico',
        label: t('s.menu.configuracao.tanquefisico'),
        filter: { type: 'text' },
      },
      {
        id: 'volumedreno',
        label: t('s.operacao.dreno.volume'),
        align: 'right',
        formatted: (v) => number(v, 2),
      },
      {
        id: 'nomeusuario',
        label: t('s.relatorio.geral.usuario'),
        filter: { type: 'text' },
      },
      { id: 'observacaodreno', label: t('s.geral.observacao') },
    ],
    []
  );
  const fields = [
    'datahoradreno',
    'nomeabreviadoposto',
    'idtanquevirtual',
    'codigotanquefisico',
    'volumedreno',
    'nomeusuario',
    'observacaodreno',
  ];
  return (
    <UnidataTable
      fixed
      redux={redux}
      header={header}
      read={recordFiltering}
      find={findOperacaoDreno}
      remove={deleteOperacaoDreno}
      form={FormDreno}
      detach="iddreno"
      keys={['iddreno']}
      excel
      pdf
      onExport={(formato) =>
        handleExportGeneric({
          endpoint: 'drenos',
          formato,
          fields,
          headers: {},
          redux,
          ordination: redux.params.ordination,
          orderfield: redux.params.orderfield,
          title: 'Relat\u00f3rio de Drenos',
          ignorarFormatacao: { volumedreno: true },
        })
      }
    />
  );
}
